// Preguntas frecuentes de la página de contacto. Viven aparte del componente
// porque también alimentan el JSON-LD FAQPage que genera el prerender -- así
// lo que lee Google/las IAs es exactamente lo que ve el usuario.
const FAQ_DATA = [
  {
    category: 'Consultoría',
    questions: [
      {
        question: '¿Qué incluye la consulta inicial gratuita?',
        answer: `La consulta inicial incluye:\n• Análisis de tus procesos actuales\n• Identificación de oportunidades de mejora\n• Recomendaciones preliminares de solución\n• Estimación de tiempo y recursos necesarios\n• Plan de implementación personalizado\n\nLa consulta tiene una duración de 60 minutos y no tiene ningún costo ni compromiso.`
      },
      {
        question: '¿Cuánto tiempo toma recibir una respuesta?',
        answer: `Nuestros tiempos de respuesta son:\n• Consultas por formulario: Menos de 24 horas\n• WhatsApp: Respuesta inmediata en horario laboral\n• Email: Máximo 4 horas en días laborales\n• Llamadas telefónicas: Atención inmediata\n\nPara consultas urgentes, recomendamos usar WhatsApp o llamar directamente.`
      },
      {
        question: '¿Ofrecen consultas en diferentes idiomas?',
        answer: `Sí, nuestro equipo maneja múltiples idiomas:\n• Español (nativo)\n• Inglés (avanzado)`
      }
    ]
  },
  {
    category: 'Servicios',
    questions: [
      {
        question: '¿Trabajan con empresas de todos los tamaños?',
        answer: `Sí, atendemos empresas de todos los tamaños:\n• Pequeñas empresas (1-10 empleados)\n• Medianas empresas (11-200 empleados)\n• Grandes empresas (200+ empleados)\n• Startups en crecimiento\n• Corporaciones multinacionales\n\nAdaptamos nuestras soluciones al tamaño y complejidad de cada organización.`
      },
      {
        question: '¿Ofrecen soporte post-implementación?',
        answer: `Sí, ofrecemos soporte integral post-implementación:\n• Soporte técnico 24/7\n• Mantenimiento preventivo\n• Actualizaciones del sistema\n• Capacitación continua\n• Optimización de procesos\n• Consultoría estratégica\n\nTenemos diferentes planes de soporte según tus necesidades.`
      }
    ]
  },
  {
    category: 'Proceso',
    questions: [
      {
        question: '¿Cómo es el proceso de implementación?',
        answer: `Nuestro proceso consta de 5 fases:\n\n1. Diagnóstico (1-2 semanas)\n   - Análisis de procesos actuales\n   - Identificación de requerimientos\n\n2. Diseño (2-3 semanas)\n   - Arquitectura de la solución\n   - Prototipo funcional\n\n3. Desarrollo (4-12 semanas)\n   - Configuración del sistema\n   - Desarrollo de personalizaciones\n\n4. Pruebas (2-3 semanas)\n   - Testing integral\n   - Capacitación de usuarios\n\n5. Go-Live (1 semana)\n   - Migración de datos\n   - Puesta en producción`
      },
      {
        question: '¿Cuánto tiempo toma una implementación típica?',
        answer: `Los tiempos varían según la complejidad:\n\n• Implementación básica: 2-3 meses\n  - Empresas pequeñas con procesos estándar\n\n• Implementación estándar: 4-6 meses\n  - Empresas medianas con algunas personalizaciones\n\n• Implementación compleja: 6-12 meses\n  - Empresas grandes con múltiples módulos\n\n• Implementación empresarial: 12+ meses\n  - Corporaciones con requerimientos complejos\n\nEl cronograma exacto se define en la fase de diagnóstico.`
      },
      {
        question: '¿Qué pasa si necesito cambios durante la implementación?',
        answer: `Manejamos cambios de manera estructurada:\n\n• Cambios menores: Sin costo adicional si están dentro del alcance\n• Cambios moderados: Evaluación de impacto y cotización\n• Cambios mayores: Revisión del proyecto y nuevo cronograma\n\nTodos los cambios se documentan y aprueban antes de implementarse. Mantenemos flexibilidad para adaptarnos a tus necesidades cambiantes.`
      }
    ]
  },
  {
    category: 'Costos',
    questions: [
      {
        question: '¿Cómo estructuran sus precios?',
        answer: `Nuestros precios se basan en:\n\n• Número de usuarios: Licencias necesarias\n• Módulos requeridos: Funcionalidades específicas\n• Nivel de personalización: Desarrollos a medida\n• Complejidad de integración: Sistemas existentes\n• Soporte incluido: Nivel de servicio post-implementación\n\nOfrecemos tres modalidades de pago: pago único, suscripción mensual, o modelo híbrido.`
      },
      {
        question: '¿Ofrecen planes de financiamiento?',
        answer: `Sí, ofrecemos varias opciones de financiamiento:\n\n• Pago en fases: Según hitos del proyecto\n• Suscripción Anual: Pagos recurrentes\n• Leasing tecnológico: A través de partners financieros\n• Descuentos por pago anticipado: Hasta 20% de descuento`
      }
    ]
  }
];

export default FAQ_DATA;
